import { render, staticRenderFns } from "./LearningTheoryAttachment.vue?vue&type=template&id=09db03b4"
import script from "./LearningTheoryAttachment.vue?vue&type=script&lang=js"
export * from "./LearningTheoryAttachment.vue?vue&type=script&lang=js"
import style0 from "./LearningTheoryAttachment.vue?vue&type=style&index=0&id=09db03b4&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports